import React from 'react';
import { AuthenticationContextDispatch, AuthenticationContextState } from '@/contexts/authentication-context';
import { useQuery } from '@tanstack/react-query';
import { fetchCurrentUser, fetchCurrentWorkspace } from '@/services/user';
import { authenticationInitialState, authenticationReducer } from '@/reducers/authentication-reducer';
import { FullScreenLoader } from '@/components/full-screen-loader';
const boot = window.__BOOTSTRAP__;
export const AuthenticationProvider = ({ children }) => {
    const [state, dispatch] = React.useReducer(authenticationReducer, authenticationInitialState);
    const { data, isSuccess, isError } = useQuery({
        queryKey: ['me'],
        queryFn: fetchCurrentUser,
        enabled: state.status === 'loading' && boot?.authenticated,
        retry: false,
        staleTime: 0,
    });
    const { data: workspace } = useQuery({
        queryKey: ['my-current-workspace'],
        enabled: state.status === 'authenticated',
        queryFn: fetchCurrentWorkspace,
    });
    React.useEffect(() => {
        if (boot?.authenticated === false && state.status === 'loading') {
            dispatch({ type: 'SIGN_OUT' });
        }
    }, [state.status]);
    React.useEffect(() => {
        if (isError)
            dispatch({ type: 'SIGN_OUT' });
    }, [isError]);
    React.useEffect(() => {
        if (isSuccess && data)
            dispatch({ type: 'SIGN_IN', user: data });
    }, [isSuccess, data]);
    React.useEffect(() => {
        if (workspace)
            dispatch({ type: 'SET_WORKSPACE', workspace });
    }, [workspace]);
    if (state.status === 'loading')
        return <FullScreenLoader text="Checking session..."/>;
    return (<AuthenticationContextState.Provider value={state}>
            <AuthenticationContextDispatch.Provider value={dispatch}>{children}</AuthenticationContextDispatch.Provider>
        </AuthenticationContextState.Provider>);
};
AuthenticationProvider.displayName = 'AuthenticationProvider';
